const StatsCards = ({ stats }) => {
  const cards = [
    {
      title: "Enrolled Courses",
      value: stats.enrolled_courses,
      icon: "fas fa-book",
      color: "#6c757d",
    },
    {
      title: "Active Courses",
      value: stats.active_courses,
      icon: "fas fa-graduation-cap",
      color: "#6c757d",
    },
    {
      title: "Completed Courses",
      value: stats.completed_courses,
      icon: "fas fa-trophy",
      color: "#6c757d",
    },
  ];

  return (
    <div className="stats-cards mb-5">
      <div className="row g-4">
        {cards.map((card, index) => (
          <div key={index} className="col-md-4">
            <div className="stat-card">
              <div className="stat-icon-container">
                <div className="stat-icon-circle">
                  <i className={card.icon} style={{ color: card.color }}></i>
                </div>
              </div>
              <div className="stat-value">{card.value}</div>
              <div className="stat-title">{card.title}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsCards;